<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { CheckIcon, IncorrectIcon, RemoveIcon } from "@infinitro/icons";
import { Input } from "@infinitro/input";
import { stateReferalCode, stateReferalCodeConfirmed } from "../state";
$: useFlat = $stateUi.modal?.modalStyle === "flat";
let element = null;
let confirmed = false;
let incorrect = false;
const BASE32_REGEX = /^[A-Z2-7]{6}$/;
const sanitize = (value) => value.toUpperCase().replace(/[^A-Z2-7]/g, "").slice(0, 6);
const onChange = () => {
	if (!element) return;
	element.value = sanitize(element.value);
	if (BASE32_REGEX.test(element.value)) {
		stateReferalCode.set(element.value);
	} else {
		stateReferalCode.set("");
	}
};
const onBlur = (event) => {
	if (!element) return;
	const _valid = element.value.length > 0 && element.checkValidity();
	if (_valid && !confirmed) {
		confirmReferalCode(event);
	}
};
export const confirmReferalCode = (event) => {
	event.preventDefault();
	return new Promise((resolve) => {
		let resolved = false;
		if (!element?.checkValidity() || confirmed) return;
		try {
			resolve(false);
		} catch (e) {
			console.log(`caught ${e}`);
			stateReferalCodeConfirmed.set(false);
		}
	});
};
const onRemove = (event) => {
	event.preventDefault();
	stateReferalCode.set("");
	stateReferalCodeConfirmed.set(false);
	confirmed = false;
};
stateReferalCode.subscribe((_value) => {
	if (_value) {
		if (element) element.value = _value;
	}
});
stateReferalCodeConfirmed.subscribe((value) => {
	confirmed = value;
});
</script>

<span class="section" class:section-flat={useFlat}>
	<div class="input">
		<Input
			id="referalcode"
			name="referalcode"
			type="text"
			placeholder={$t(Verbiage.referal_code)}
			disabled={confirmed}
			bind:element
			error={incorrect}
			onInput={onChange}
			{onBlur}
			customClasses={useFlat ? 'auth-flat-input' : ''}
			customBorderRadius={useFlat ? '8px' : undefined}
			inputClasses={useFlat ? 'auth-flat-input-el' : ''}
		/>
		{#if confirmed}
			<a class="trailing-icon" href={'#'} on:click={onRemove} tabindex="-1">
				<RemoveIcon />
			</a>
		{/if}
	</div>
	{#if incorrect}<IncorrectIcon />{:else if confirmed}
		<CheckIcon />
	{/if}
</span>

<style>
	.section {
		display: flex;
		width: 100%;
		align-items: center;
}

	.section-flat {
		width: 100%;
		gap: 10px;
		padding-top: 0px;
		padding-bottom: 0px;
}

	div.input {
		position: relative;
		width: 100%;
}
	.trailing-icon {
		pointer-events: auto;
		position: relative;
		top: 32px;
		right: 0px;
		display: flex;
		align-items: center;
		padding-right: 0.875rem;
}

	:global(.auth-flat-input) {
		background: var(--color-background-500) !important;
		border: 0 !important;
		height: 48px !important;
	}

	:global(.auth-flat-input::before),
	:global(.auth-flat-input::after) {
		content: none !important;
	}
</style>
